/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { ChildrenType, MixType } from 'Type/Common.type';

import TabComponent from './Tab.component';

/** @namespace Scandipwa/Component/Tab/Container */
export class TabContainer extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
        mix: MixType,
        children: ChildrenType.isRequired
    };

    static defaultProps = {
        isActive: false,
        mix: {}
    };

    containerProps = () => ({
        isActive: this._getIsActive(),
        mix: this._getMix()
    });

    _getMix() {
        const { mix } = this.props;

        return mix;
    }

    _getIsActive() {
        const { isActive } = this.props;

        return isActive;
    }

    render() {
        const { children } = this.props;

        return (
            <TabComponent
              { ...this.containerProps() }
            >
                { children }
            </TabComponent>
        );
    }
}

export default TabContainer;
